import { ReferenceListing } from '@/types-reference-listing';

export interface FeaturedPlacement {
  customerId: string;
  type: FeaturedPlacementTypeEnum;
  highlightedListings?: Array<ReferenceListing>;
  agentEmail?: string;
}

export enum ApiCallStatus {
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum FeaturedPlacementTypeEnum {
  BRAND = 'brand',
  REFERENCE_PROPERTIES = 'reference_properties',
}
